export default __webpack_public_path__ + "static/media/header-logo1.ceeb58b0.png";